import {Component, OnInit, Output, EventEmitter, Input, ElementRef, ViewChild, OnDestroy} from '@angular/core';
import {Project} from 'projects/app-misc/src/app/modules/project-misc/data/project/project';
import {ProjectService} from 'projects/app-misc/src/app/modules/project-misc/data/project/project.service';
import {SearchService} from 'projects/app-misc/src/app/modules/search/data/search.service';
import {distinctUntilChanged, takeUntil} from 'rxjs/operators';
import {LocalStorage} from 'ngx-webstorage';
import {UserProjectsHistory} from '../../../data/userProjectsHistory';
import {AppStateQuery} from '../../../../../../../../desktop/src/app/data/app-state.query';
import {User} from '../../../../../../../../core/src/lib/login/data/user';
import {Subject} from 'rxjs';
import {RxJSUnsubscribe} from '../../../../../../../../core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import {RxJSUnsubscribable} from '../../../../../../../../core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import {ShortProject} from '../../../../project-misc/data/project/short-project';

@Component({
  selector: 'app-choose-project',
  templateUrl: './choose-project.component.html',
  styleUrls: ['./choose-project.component.scss'],
  providers: [SearchService]
})
@RxJSUnsubscribe
export class ChooseProjecComponent implements OnInit, OnDestroy, RxJSUnsubscribable {

  currentUser: User;

  projects: ShortProject[];
  allProjects: ShortProject[];

  projectsIsLoading = false;

  @Output()
  projectIsChoosen = new EventEmitter<Project>();

  constructor(
    protected projectService: ProjectService,
    protected appStateQuery: AppStateQuery,
    protected searchService: SearchService
  ) {

    this.appStateQuery.currentUser$
      .pipe(
        takeUntil(this.getUnsubFromAllSubs())
      )
      .subscribe(currentUser => this.currentUser = currentUser)
  }

  ngOnInit(): void {
    this.projectsIsLoading = true;

    this.projectService.getLastProjectsForClockIn().subscribe(projects => {
      this.projects = projects
      this.allProjects = this.projects

      this.projectsIsLoading = false;
    })

    this.searchService
      .keyword$
      .pipe(
        distinctUntilChanged()
      )
      .subscribe(searchValue => {
        if (searchValue) {
          this.projects = this.allProjects.filter(project => project.name.toLowerCase().includes(searchValue.toLowerCase()))
        } else {
          this.projects = this.allProjects
        }
      })
  }

  searchMethod(searchValue: string) {
    this.searchService.emitKeyword(searchValue);
  }

  chooseProject(project: Project) {
    this.projectIsChoosen.emit(project)
  }

  backButton() {
    this.projectIsChoosen.emit()
  }

  getUnsubFromAllSubs(): Subject<boolean> {
    return null
  }


  ngOnDestroy() {
  }

}
